import { LockOutlinedIcon } from '~/index.ts';
import Button, { ButtonProps } from '../../atoms/Button/Button.tsx';
import { FormMode, FormSection } from './FormSectionLayout.tsx';
import { Box } from '@mui/system';

interface FormActionButtonProps extends Omit<ButtonProps, 'children'> {
  isEditing: boolean;
  section: FormSection;
  formMode?: FormMode;
  useAddRemove?: boolean;
  hasSectionValues?: boolean;
  dataTestId?: string;
  addText?: string;
}

const FormActionButton: React.FC<FormActionButtonProps> = ({
  isEditing,
  section,
  formMode,
  useAddRemove,
  hasSectionValues,
  addText,
  ...restProps
}) => {
  if (formMode === 'add' && !section.allowAdd) {
    return null;
  }

  const addModeText =
    isEditing || hasSectionValues ? 'Remove' : addText ?? 'Add';
  const editModeText = isEditing ? 'Cancel' : 'Edit';
  const buttonText =
    useAddRemove && !hasSectionValues ? addModeText : editModeText;

  const isLocked = formMode === 'edit' && section.disableEdit;
  const boxSx = isLocked
    ? { margin: '10px 16px 0 auto' }
    : { marginLeft: 'auto' };

  const content = isLocked ? (
    <LockOutlinedIcon
      data-test-id={`${restProps.dataTestId}-lock-outlined-icon`}
    />
  ) : (
    <Button
      variant="text"
      disableRipple
      {...restProps}
      data-test-id={`form-action-button-${section.key}`}
    >
      {buttonText}
    </Button>
  );

  return <Box sx={boxSx}>{content}</Box>;
};

export default FormActionButton;
